import { render, staticRenderFns } from "./AppSearchResultFancy.vue?vue&type=template&id=5c88b1d3"
import script from "./AppSearchResultFancy.vue?vue&type=script&lang=js"
export * from "./AppSearchResultFancy.vue?vue&type=script&lang=js"
import style0 from "./AppSearchResultFancy.vue?vue&type=style&index=0&id=5c88b1d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports